import React, { useEffect, useMemo, useState } from "react";
import "./productDetails.css";
import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";
import SimilarProducts from "./similarProduct";
import Bottom from "./Bottom";
import BackArrow from "../../../src/assets/backArrow.png";
import Procced from "../../ProccedToPay/component";
import ReplaceCartModal from "../../PopUp/ReplaceCartPopUp";
import DetailRow from "./listData.jsx";

// TODO: move to an env var (REACT_APP_S3_BASE_URL) rather than hardcoding.
const BASE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/";

const ImageCarousel1 = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setCurrentIndex((i) => (i + 1) % images.length),
    onSwipedRight: () => setCurrentIndex((i) => (i === 0 ? images.length - 1 : i - 1)),
    trackMouse: true,
  });

  if (images.length === 0) return null;

  const nextImage = () => setCurrentIndex((i) => (i + 1) % images.length);
  const prevImage = () => setCurrentIndex((i) => (i === 0 ? images.length - 1 : i - 1));

  return (
    <div style={{ padding: "20px" }}>
      <div className="carousel" {...swipeHandlers}>
        <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} />

        <div className="nav-left" onClick={prevImage} />
        <div className="nav-right" onClick={nextImage} />

        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`dot ${index === currentIndex ? "active" : ""}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const ProductDetails = (props) => {
  const {
    productDetailsData,
    cartItemsList,
    cartItemsList1,
    similarProduct,
    imagePaths,
    AddIntoCart,
    RemovefromCart,
    totalAmount,
    countProduct,
    replaceCard,
    setReplceCard,
    replaceMyCard,
  } = props;

  const navigate = useNavigate();

  const matchingData = cartItemsList?.[0] ? cartItemsList : cartItemsList1 ?? [];

  // Previously ran a .find() per similarProduct item (O(n*m)). A single
  // Map built once from matchingData makes each lookup O(1).
  const mergedData = useMemo(() => {
    const countBySlot = new Map(matchingData.map((m) => [m.slotId, m.count]));
    return (similarProduct || []).map((item) => ({
      ...item,
      mycount: countBySlot.has(item.slot_id) ? countBySlot.get(item.slot_id) : item.mycount,
    }));
  }, [similarProduct, matchingData]);

  const images = useMemo(
    () => (imagePaths || []).map((img) => (img.includes("http") ? img : `${BASE_URL}${img}`)),
    [imagePaths]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    // Previously also started a setInterval that incremented a local
    // currentIndex used nowhere (ImageCarousel1 owns its own index
    // internally) — a needless re-render every 3s for the life of this
    // page. Removed.

    // App.css sets a gradient on <body> globally; this page wants a plain
    // white background, so override it here and restore on unmount.
    const prevBackground = document.body.style.background;
    document.body.style.background = "#ffffff";
    return () => {
      document.body.style.background = prevBackground;
    };
  }, []);

  const handleBack = () => {
    const machineId = localStorage.getItem("machineId");
    navigate(`/items?machineId=${machineId}&showItems=true`);
  };

  return (
    <>
      {productDetailsData?.isSample === false && countProduct ? (
        <Procced
          preCart={cartItemsList?.[0] && cartItemsList}
          bottom="110px"
          totalAmount={totalAmount}
          productDetailsData={productDetailsData}
          pdp
        />
      ) : null}

      {replaceCard && (
        <ReplaceCartModal setReplaceCard={setReplceCard} replaceMyCardFun={replaceMyCard} />
      )}

      <header className="header" style={{ position: "fixed", width: "100%", top: 0, zIndex: 999 }}>
        <img src={BackArrow} style={{ width: "20px" }} onClick={handleBack} alt="back" />
        <h1 style={{ marginLeft: "10px", color: "#583C43", fontSize: "18px" }}>
          {productDetailsData?.productName}
        </h1>
      </header>

      <div className="container-product-detail" style={{ marginTop: "60px" }}>
        <ImageCarousel1 images={images} />

        <DetailRow productDetailsData={productDetailsData} />

        <SimilarProducts
          similarProduct={mergedData}
          AddIntoCart={AddIntoCart}
          RemovefromCart={RemovefromCart}
        />

        <Bottom
          productDetailsData={productDetailsData}
          cartItemsList={cartItemsList}
          AddIntoCart={AddIntoCart}
          RemovefromCart={RemovefromCart}
        />
      </div>
    </>
  );
};

export default ProductDetails;